namespace $.$$ {

	export class $shm_ba_filter_panel extends $.$shm_ba_filter_panel {

		state() {
			return super.state() as $shm_ba_filter_state_store
		}

		data() {
			return super.data() as $shm_ba_data
		}

		dev_mode() {
			return this.$.$mol_state_arg.value( 'dev_mode' ) === 'true'
		}

		filters_head_rows() {
			return [
				this.Filters_title(),
				this.Summary_expand(),
				this.dev_mode() ? this.Process_monitor_toggle() : null,
				this.Filter_reset(),
			].filter( Boolean ) as readonly $mol_view[]
		}

		period( next?: $shm_ba_data_period ) {
			return this.state().period( next )
		}

		period_all() {
			return this.state().period_all()
		}

		tags_filter( next?: $shm_ba_data_filter ) {
			return this.state().tags_filter( next )
		}

		authors_filter( next?: $shm_ba_data_filter ) {
			return this.state().authors_filter( next )
		}

		sources_filter( next?: $shm_ba_data_filter ) {
			return this.state().sources_filter( next )
		}

		message_types_filter( next?: $shm_ba_data_filter ) {
			return this.state().message_types_filter( next )
		}

		source_types_filter( next?: $shm_ba_data_filter ) {
			return this.state().source_types_filter( next )
		}

		search_query( next?: string ) {
			return this.state().search_query( next )
		}

		@ $mol_mem
		search_query_draft( next?: string ) {
			if( next === undefined ) return this.search_query()
			return next
		}

		search_index_status() {
			if( !this.has_source() ) return ''

			const mode = this.state().search_mode()
			if( mode === 'fts' ) {
				if( this.data().fts_indexing() ) return 'Индексация...'
				if( this.data().fts_index_built() ) return 'Индексация готова'
				return 'Индексация при первом поиске'
			}
			return 'Без индекса'
		}

		tags() {
			return this.data().tags()
		}

		authors() {
			return this.data().authors()
		}

		sources() {
			return this.data().sources()
		}

		message_types() {
			return this.data().message_types()
		}

		source_types() {
			return this.data().source_types()
		}

		filters_rows() {
			if( !this.has_source() ) return [ this.Empty() ]
			return [
				this.Period_section(),
				this.Search_section(),
				this.Tags_section(),
				this.Message_types_section(),
				this.Source_types_section(),
				this.Sources_section(),
				this.Authors_section(),
			]
		}

		search_submit( next?: Event ) {
			if( next === undefined ) return null
			this.search_query( this.search_query_draft() )
			return next
		}

		search_clear( next?: Event ) {
			if( next === undefined ) return null
			this.search_query_draft( '' )
			this.search_query( '' )
			return next
		}

		filter_reset( next?: Event ) {
			if( next === undefined ) return null
			this.state().reset()
			return next
		}

		summary_expanded( next?: boolean ) {
			return this.$.$mol_state_local.value< boolean >( 'hitalama_ba_filters_summary_expanded', next ) ?? false
		}

		summary_more_expanded( next?: boolean ) {
			return this.$.$mol_state_local.value< boolean >( 'hitalama_ba_filters_summary_more_expanded', next ) ?? false
		}

		filter_summary_limit() {
			return 3
		}

		is_period_all() {
			const period = this.period()
			const all = this.period_all()
			return period.from === all.from && period.to === all.to
		}

		filter_label( title: string, filter: $shm_ba_data_filter, table: $shm_ba_data_table | null ) {
			const names = table?.rows.map( ([ name ])=> String( name ) ) ?? []
			const selected = names.filter( name => filter[ name ] === true )
			const rejected = names.filter( name => filter[ name ] === false || filter[ name ] === 'exclude' )

			if( !names.length || !Object.keys( filter ).length ) return ''
			if( selected.length === names.length && !rejected.length ) return ''
			if( filter.__all__ === false && !selected.length ) return `${ title }: ничего`

			const values = rejected.length && ( !selected.length || rejected.length <= selected.length )
				? `все кроме ${ rejected.join( ', ' ) }`
				: selected.join( ', ' ) || 'ничего'

			return `${ title }: ${ values }`
		}

		period_label_date( date: string ) {
			const day = this.$.$shm_date.text( date.slice( 0, 10 ) )
			const time = date.match( /^\d{4}-\d{2}-\d{2}[ T](\d{2}:\d{2})/ )?.[1]
			return time ? `${ day } ${ time }` : day
		}

		filter_summary_labels() {
			if( !this.has_source() ) return []

			const period = this.period()
			return [
				this.is_period_all() ? '' : `Период: ${ this.period_label_date( period.from ) } - ${ this.period_label_date( period.to ) }`,
				this.search_query().trim() ? `Поиск: ${ this.search_query().trim() }` : '',
				this.filter_label( 'Теги', this.tags_filter() as $shm_ba_data_filter, this.tags() ),
				this.filter_label( 'Тип сообщения', this.message_types_filter() as $shm_ba_data_filter, this.message_types() ),
				this.filter_label( 'Тип источника', this.source_types_filter() as $shm_ba_data_filter, this.source_types() ),
				this.filter_label( 'Источники', this.sources_filter() as $shm_ba_data_filter, this.sources() ),
				this.filter_label( 'Авторы', this.authors_filter() as $shm_ba_data_filter, this.authors() ),
			].filter( Boolean )
		}

		filter_summary_label( label: string ) {
			return label
		}

		filter_summary_more_title() {
			return this.summary_more_expanded() ? 'Скрыть' : 'Еще'
		}

		filter_summary_more( next?: Event ) {
			if( next === undefined ) return null
			this.summary_more_expanded( !this.summary_more_expanded() )
			return next
		}

		filter_summary_content() {
			if( !this.summary_expanded() ) return []

			const labels = this.filter_summary_labels()
			if( !labels.length ) return [ this.Filter_summary_label( 'Выбранные фильтры: все' ) ]

			const limit = this.filter_summary_limit()
			const visible = this.summary_more_expanded() ? labels : labels.slice( 0, limit )
			const rows = visible.map( label => this.Filter_summary_label( label ) ) as $mol_view[]

			if( labels.length > limit ) rows.push( this.Filter_summary_more() )
			return rows
		}

	}

}
